import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import PropTypes from 'prop-types';

import SpacingBody from './SpacingBody';
import SpacingData from './SpacingData';

const Edit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <div style={{ padding: '1px 0' }}>
        <SpacingBody data={data} id={block} />
      </div>
      <SidebarPortal selected={selected}>
        <SpacingData
          key={block}
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  data: PropTypes.shape({
    size: PropTypes.string,
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default withBlockExtensions(Edit);
